export default __webpack_public_path__ + "static/media/MAGNETIC_ENCODER.1cbfa873.png";